import React from "react";
import {Link} from "react-router-dom";

const NotFoundComponent = () => {
    return (
        <div className="section" id="about">
            <div className="container">
                <div className="card" data-aos="fade-up" data-aos-offset="10">
                    <div className="row">

                        <div className="col-lg-12 col-md-12">
                            <div className="card-body">
                                <div className="h4 mt-0 title">Error code: 404</div>

                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        Whoops! Page Not Found
                                        <br/>
                                        <Link to='/' className='btn btn-danger'>Go Back</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default NotFoundComponent